<sgt-grupo-classificacao-classificavel-form
    #form
    [canEdit]="canEdit"
    [entities]="entities">
</sgt-grupo-classificacao-classificavel-form>